import { writable } from 'svelte/store';
import { call } from "$lib/Api/Api.svelte";

const addressTypes = writable([]);

const addressTypeStore = {
  subscribe: addressTypes.subscribe,
  load: (id) => {
    return call("address-types", "query")
      .then((data) => {
        addressTypes.set(data);
      })
      .catch((err) => {});
  },
};

export default addressTypeStore;